import { useHistory, useParams } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import useProfiles from 'flow/hooks/useProfiles';
import { generatePath } from 'flow/utils/router-utils';
import Page from '../Setting/Page';
import RouteLink from '../ui-components/RouteLink';
import { ExtensionKey } from 'flow/types/EntityKeys';

const SettingsSMSProfileChooser = () => {
    const { extensionKey } = useParams<{ extensionKey: ExtensionKey }>();
    const { profiles } = useProfiles(extensionKey);
    const history = useHistory();

    return (
        <Page
            header="settings.profile_edit"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.callerid'], { extensionKey }),
                )
            }
        >
            {profiles.map((profile) => (
                <RouteLink
                    key={profile.get('key')}
                    to={generatePath(
                        routes['settings.callerid.profile.sms.edit.profileKey'],
                        {
                            extensionKey,
                            profileKey: profile.get('key'),
                        },
                    )}
                    description={profile.getIn([
                        'smsSenderNameId',
                        'description',
                    ])}
                >
                    {profile.get('description')}
                </RouteLink>
            ))}
        </Page>
    );
};

export default SettingsSMSProfileChooser;
